export default __webpack_public_path__ + "static/aboutOG-a4dd6ee36448c13531f21707db6139d5.jpg";